import { ArrowUpRight, Circle, Trash2 } from "lucide-react";
import { DragBox } from "./DragBox";
import { ArrowBox } from "./ArrowBox";
import { newArrow, newCircle } from "@/lib/thumbnail";

// Overlay handles for every red arrow and circle on the thumbnail.
export function ShapeLayer({ stageRef, shapes, setShapes, commit, selected, setSelected }) {
  const change = (s) => setShapes(shapes.map((o) => (o.id === s.id ? s : o)));
  return shapes.map((s, i) => (s.type === "arrow"
    ? <ArrowBox key={s.id} stageRef={stageRef} shape={s} testId={`thumb-shape-${i}`} active={selected === s.id}
        onSelect={() => setSelected(s.id)} onChange={change} onCommit={commit} />
    : <DragBox key={s.id} stageRef={stageRef} testId={`thumb-shape-${i}`} label="circle" box={s} active={selected === s.id}
        onSelect={() => setSelected(s.id)} onChange={(b) => change({ ...s, ...b })} onCommit={commit} />));
}

const btn = "flex items-center gap-1.5 border border-zinc-200 hover:border-rose-400 hover:text-rose-600 disabled:opacity-40 disabled:pointer-events-none text-zinc-700 text-sm rounded-[4px] px-3.5 py-2 transition-colors";

export function ShapeToolbar({ shapes, onSave, selected, setSelected }) {
  const add = (s) => { onSave([...shapes, s]); setSelected(s.id); };
  return (
    <div className="flex flex-wrap gap-2" data-testid="thumb-shape-toolbar">
      <button type="button" className={btn} disabled={shapes.length >= 20} onClick={() => add(newArrow())} data-testid="thumb-add-arrow-btn"><ArrowUpRight size={15} /> Add Arrow</button>
      <button type="button" className={btn} disabled={shapes.length >= 20} onClick={() => add(newCircle())} data-testid="thumb-add-circle-btn"><Circle size={15} /> Add Circle</button>
      <button type="button" className={btn} disabled={!shapes.some((s) => s.id === selected)} data-testid="thumb-delete-shape-btn"
        onClick={() => { onSave(shapes.filter((s) => s.id !== selected)); setSelected(null); }}><Trash2 size={15} /> Delete Selected</button>
    </div>
  );
}
